import { API, graphqlOperation, Storage } from 'aws-amplify';
import { Dispatch } from 'redux';
import { searchProductswithimagekey } from '../../../graphql/custom_queries';
import {
  createFavoriteBrand,
  deleteFavoriteBrand,
} from '../../../graphql/mutations';
import { searchFavoriteBrands } from '../../../graphql/queries';
import {
  appendFavoriteBrand,
  FavoriteBrand,
  removeFavoriteBrand as removeFavoriteBrandAction,
  setFavoriteBrand,
  setFavoriteBrands,
} from '../actions';
import { AuthUser } from '~redux/auth/actions/authUser';
import { pushFollowBrandEvent, pushUnfollowBrandEvent } from '~utils/gtm';
import { getPublicImageUrl } from '~utils/image';
import { brandFollowed } from '~utils/segment';

export const addFavoriteBrand = (
  user: AuthUser,
  brand_id: string,
  noAppend?: boolean
) => {
  return async (dispatch: Dispatch): Promise<void> => {
    const exist = await API.graphql<any>(
      graphqlOperation(searchFavoriteBrands, {
        filter: {
          account_id: { eq: user.attributes.sub },
          brand_id: { eq: brand_id },
        },
      })
    );

    if (exist?.data?.searchFavoriteBrands?.items?.length) {
      const favoriteBrand = exist.data.searchFavoriteBrands.items[0];
      dispatch(setFavoriteBrand({ id: favoriteBrand.id, brand_id }));
      return;
    }

    const res = await API.graphql<any>(
      graphqlOperation(createFavoriteBrand, {
        input: { account_id: user.attributes.sub, brand_id },
      })
    );

    const {
      data: { createFavoriteBrand: item },
    } = res;

    if (!noAppend) {
      dispatch(appendFavoriteBrand(item));
    }

    brandFollowed({
      brand_id,
      name: item?.brand?.brand_name,
      category: item?.brand?.brand_category,
    });

    pushFollowBrandEvent(user, item.brand);
  };
};

export const removeFavoriteBrand = (
  id: string,
  user: AuthUser,
  noRemove?: boolean
) => {
  return async (dispatch: Dispatch): Promise<void> => {
    const res = await API.graphql<any>(
      graphqlOperation(deleteFavoriteBrand, {
        input: { id },
      })
    );

    const {
      data: { deleteFavoriteBrand: item },
    } = res;

    if (!noRemove) {
      dispatch(removeFavoriteBrandAction(id));
    }

    pushUnfollowBrandEvent(user, item.brand);
  };
};

export const getFavoriteBrands = (account_id: string, product?: boolean) => {
  return async (dispatch: Dispatch): Promise<void> => {
    const res = await API.graphql<any>(
      graphqlOperation(searchFavoriteBrands, {
        filter: { account_id: { eq: account_id } },
        sort: { direction: 'desc', field: 'createdAt' },
      })
    );

    const {
      data: {
        searchFavoriteBrands: { items },
      },
    } = res;

    const favoriteBrands: FavoriteBrand[] = await Promise.all(
      items.map(async (item: any) => {
        let products = [];
        if (product) {
          const res = await API.graphql<any>(
            graphqlOperation(searchProductswithimagekey, {
              filter: {
                product_brand_id: { eq: item.brand.id },
                product_public_status: { eq: '公開' },
                suspended: { ne: true },
              },
              sort: { field: 'createdAt', direction: 'desc' },
              limit: 10,
            })
          );
          const {
            data: {
              searchProducts: { items },
            },
          } = res;
          products = items;
        }

        return {
          ...item,
          brand: {
            ...item.brand,
            product: {
              items: await Promise.all(
                products.map(async (product: any) => ({
                  ...product,
                  imageUrl: getPublicImageUrl(
                    product.imageKeys.items[0]?.imageKey
                  ),
                }))
              ),
            },
          },
        };
      })
    );

    dispatch(setFavoriteBrands(favoriteBrands));
  };
};

export const getFavoriteBrand = (account_id: string, brand_id: string) => {
  return async (dispatch: Dispatch): Promise<void> => {
    const res = await API.graphql<any>(
      graphqlOperation(searchFavoriteBrands, {
        filter: { account_id: { eq: account_id }, brand_id: { eq: brand_id } },
      })
    );

    const {
      data: {
        searchFavoriteBrands: { items },
      },
    } = res;

    dispatch(setFavoriteBrands(items));
  };
};
